import styled from 'styled-components';

export const StyledIframe = styled.iframe`
	width: 100%;
	height: 100%;
	overflow: auto;
`;

export const iframeStyles = `
	* {
		pointer-events: none !important;
		user-select: none !important;
		-webkit-user-select: none !important;
		-moz-user-select: none !important;
		-ms-user-select: none !important;
	}
`;
